import ClassSessionsPanel from "./panels/ClassSessionsPanel";

const tabRoutes = [
  {
    name: "Class Sessions",
    path: "/classsessions",
    component: <ClassSessionsPanel />
  }
];

export default tabRoutes;
